import { Link } from "react-router-dom";
import { useState } from "react";
import { Pencil, SquareX, CirclePlus,DollarSign } from "lucide-react";
import { GetServicios } from "../../actions/servicio";
import { GetInsumos } from "../../actions/Insumo";
import { GetPagos } from "../../actions/pagos";
import { Presupuesto } from "../../actions/presupuesto";
import { useProducto } from "../../actions/Producto";
import { GotoLogin } from "../../actions/renovarLog";
import { useMutation } from "@tanstack/react-query";
import style from "../../styles/grid.module.css";

const Presupuestos = () => {
   // ...existing code...
   const [currentPage, setCurrentPage] = useState(1);
   const [showFactDateModal, setShowFactDateModal] = useState(false);
   const [factDate, setFactDate] = useState(new Date().toISOString().slice(0, 10));
   const [factId, setFactId] = useState(null);
   const recordsPerPage = 20;
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "presupuesto";
   var urlFac = process.env.REACT_APP_URL_DIR + "factura";
   const { GetProductos } = useProducto();

   const presupuesto = Presupuesto(1);
   const servicios = GetServicios();
   const pagos = GetPagos();
   const insumos = GetInsumos();
   // const insumost = GetInsumost();
   const productos = GetProductos();

   // Calcula los registros a mostrar
   const indexOfLastRecord = currentPage * recordsPerPage;
   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

   const totalPages = Math.ceil((presupuesto?.length || 0) / recordsPerPage);

   const { mutate: graboFact } = useMutation({
      mutationFn: ({ id, fecha }) =>
         fetch(urlFac + "/" + id, {
            method: "POST",
            body: JSON.stringify({ fecha }),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/presupuesto";
      },
      onError: () => {
         alert("Error en datos ingresados");
      },
   });
   const { mutate } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Presupuesto";
      },
      onError: () => {
         alert("Error");
      },
   });
   const numberFormat = new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
   });

   const formatDate = (fecha) => {
      var newDate1 = fecha.substring(0, 10).split("-");
      var newdate2 = newDate1[2] + "/" + newDate1[1] + "/" + newDate1[0];
      return newdate2;
   };

   console.log("presupuesto: ", presupuesto);
   if (!presupuesto || !servicios || !pagos || !insumos || !productos) {
      return <div>Cargando datos...</div>;
   }
   if (presupuesto.message === "Token inválido") {
      return <GotoLogin />;
   }
   const handleFact = (id) => {
      console.log('id: ', id);
      setFactId(id);
      setFactDate(new Date().toISOString().slice(0, 10));
      setShowFactDateModal(true);
   };

   const handleFactDateConfirm = () => {
      const fecha = factDate.trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
         alert("Formato de fecha inválido. Use YYYY-MM-DD.");
         return;
      }
      if (!factId) {
         return;
      }

      graboFact({ id: factId, fecha });
      setShowFactDateModal(false);
      setFactId(null);
   };

   const handleFactDateCancel = () => {
      setShowFactDateModal(false);
      setFactId(null);
   };
   const handleRemove = (id) => {
      let text =
         "Se va a eliminar el presupuesto selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         mutate(id);
      }
   };

   if (presupuesto) {
      if (presupuesto.message) {
         return (
            <div className={style.tableCli}>            
               <div>
                  <div className={style.gridTitle}>
                     <h2>Orden Piercing</h2>
                  </div>               
               </div>
               <div>
                  <div>
                     <Link
                        to={"/formPresupuesto"}
                        className="dLink"
                        title="Nuevo Presupuesto"
                        state={{
                           id: 0,
                           id_primary: 0,
                        }}
                     >
                         <CirclePlus className="lucidePlus" />
                        {/* {" "}
                        <button className={style.inputBtnNew}>
                           Nueva Orden
                        </button> */}
                     </Link>
                     &nbsp;&nbsp;
                  </div>
               </div>
               <div style={{ color: "white" }}>No hay Ordenes Cargados</div>
            </div>
         );
      }
   }

   const currentRecords =
      presupuesto?.slice(indexOfFirstRecord, indexOfLastRecord) || [];

   return (
      <>
         <div className={style.tableCli}>
            <div >
               <div >
                  <h2>Orden Piercing</h2>
               </div>
            </div>
            <div>
               <div>
                  <Link
                     to={"/formPresupuesto"}
                     className="dLink"
                     title="Nueva Orden"
                     state={{
                        id: 0,
                        id_primary: 0,
                        // cod_serv: 0,
                        // observaciones:"",
                        // servicios: servicios,
                        // pagos: pagos,
                        // insumos: insumos,
                        // // insumost: insumost,
                        // productos: productos,
                        // documento: 0,
                        // nombre: "",
                     }}
                  >
                     <CirclePlus className="lucidePlus" />
                  </Link>
                  &nbsp;&nbsp;
               </div>
            </div>
            <br />
            <table className={style.gridFact}>
               <thead>
                  <tr className={style.trTitle}>
                     <th style={{ width: "50%" }}>Cliente</th>
                     <th style={{ width: "12%" }}>Documento</th>
                     <th style={{ width: "12%" }}>Fecha</th>
                     <th style={{ width: "15%" }}>Total</th>
                     <th style={{ width: "14%" }}>Acciones</th>
                  </tr>
               </thead>
               <tbody>
                  {currentRecords &&
                     currentRecords?.map((data) => {
                        // console.log("presupuesto_data: ", data);
                        return (
                           <tr key={data.id} className={style.trdatos}>
                              <td className={style.style_td}>
                                 {data.cliente.nombre}
                              </td>
                              <td className={style.style_td}>
                                 {data.cliente.documento}
                              </td>
                              <td className={style.style_td}>
                                 {formatDate(data.fecha)}
                              </td>
                              <td className={style.precio}>
                                 $ {numberFormat.format(data.total)}
                              </td>
                              <td>
                                 <Link
                                    to={"/formPresupuesto"}
                                    className="dLink"
                                    state={{
                                       id: data.id,
                                       id_primary: data.id_primary,
                                       // observaciones:data.observaciones,
                                       // cod_serv: servicios[0].id,
                                       // servicios: servicios,
                                       // pagos: pagos,
                                       // insumos: insumos,
                                       // // insumost: insumost,
                                       // productos: productos,
                                       // netoprod:data.netoprod,
                                       // netoinsumo:data.netoinsumo,
                                       // presupuesto: data,
                                       // cod_status:data.cod_status
                                    }}
                                 >
                                    <Pencil />
                                 </Link>
                                 &nbsp;&nbsp;
                                 <span
                                    title="Facturar Presupuesto"
                                    className="lucideIcon"
                                    onClick={() => handleFact(data.id_primary)}
                                 >
                                    <DollarSign />
                                 </span>

                                 &nbsp;&nbsp;
                                 <span
                                    title="Eliminar Producto"
                                    className="lucideIconDel"
                                    onClick={() => handleRemove(data.id)}
                                 >
                                    <SquareX />
                                 </span>
                              </td>
                           </tr>
                        );
                     })}
               </tbody>
            </table>
            {/* </div> */}
            {/* Paginación */}
            <div style={{ margin: "16px 0", textAlign: "center" }}>
               <button
                  className={style.inputBtnNew}
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  disabled={currentPage === 1}
               >
                  Anterior
               </button>
               <span style={{ margin: "0 12px", color: "white" }}>
                  Página {currentPage} de {totalPages}
               </span>
               <button
                  className={style.inputBtnNew}
                  onClick={() =>
                     setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
               >
                  Siguiente
               </button>
            </div>
         </div>
         {showFactDateModal && (
            <div className={style.modalOverlay} onClick={handleFactDateCancel}>
               <div
                  className={style.modalContent}
                  onClick={(event) => event.stopPropagation()}
               >
                  <h3 className={style.modalTitle}>Fecha de Factura</h3>
                  <input
                     type="date"
                     value={factDate}
                     onChange={(event) => setFactDate(event.target.value)}
                     className={style.modalDateInput}
                  />
                  <div className={style.modalActions}>
                     <button
                        type="button"
                        className={style.inputBtnNew}
                        onClick={handleFactDateConfirm}
                     >
                        Aceptar
                     </button>
                     <button
                        type="button"
                        className={style.inputBtnNew}
                        onClick={handleFactDateCancel}
                     >
                        Cancelar
                     </button>
                  </div>
               </div>
            </div>
         )}
      </>
   );
};

export default Presupuestos;
